import type { LabwareDefinition } from '../types'

export const getLabwareDefURI = (def: LabwareDefinition): string =>
  constructLabwareDefURI(
    def.namespace,
    def.parameters?.loadName, // custom labware might be missing parameters?
    String(def.version)
  )

export const constructLabwareDefURI = (
  namespace: string,
  loadName: string,
  version: string
): string => `${namespace}/${loadName}/${version}`
